import { Injectable, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';


import { DOCUMENT } from '@angular/platform-browser';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { CommonModule } from '@angular/common';
// import { Router } from '@angular/router';
//'TVSNext': 'SunNetwork'

@Injectable()
export class GlobalserviceService {

    constructor(public http: HttpClient, private router: Router) { }
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    /**API url */
    // Server url with public access

   // base_url = 'http://10.91.19.198:86';
     //base_url="http://10.91.19.198:81/"

    // Local Server url

   // base_url = 'http://10.91.16.163:86/';
    //base_url='http://10.91.16.192:86'
   // base_url = 'http://10.91.19.198:83/' ;
    base_url = 'http://10.200.2.121:81/' ;
     //commented on dated 20-12-2018
    //local based public url 16/aug
   //  base_url= 'http://14.141.212.155:83/'
 // base_url='http://115.112.102.211:81'


    // loader

    Loader = new Subject<Boolean>();
    enableloader() {
    this.Loader.next(false);
    }

    disableloader() {
    this.Loader.next(true);
    }

    getLoaderStatus(): Observable<any> {
    return this.Loader.asObservable();
    }

    tiggerload(): Observable<Object> {
        return;
    }

    signin(data): Observable<any> {
      console.log(data); debugger;
        return this.http.post(this.base_url + '/api/AdminUser/AdminLogin', data );
     }

    qrdata(qrdata): Observable<any> {
       return this.http.post(this.base_url + '/api/BarCode/GenerateCode', qrdata , { headers: this.headers });
    }

    createUser(Users): Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/CreateUser', Users );
    }
    location(): Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/GetLocation',  { headers: this.headers });
    }
    Userall(): Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/GetAdminHistory',  { headers: this.headers });
     }
     ODlist(): Observable<any> {
        return this.http.get(this.base_url + '/api/AdminUser/GetODUserLists');
     }
     EnableDis(enabledata): Observable<any> {
      return this.http.post(this.base_url + '/api/AdminUser/EnableDisable', enabledata);
     }
     OD_Details(Details): Observable<any> {
       return this.http.post(this.base_url + '/api/AdminUser/GetODDetails', Details, { headers: this.headers });
    }
    OD_total(): Observable<any> {
      return this.http.get(this.base_url + '/api/AdminUser/GetUserODCount',  { headers: this.headers });
    }
    ActiveState(data): Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/ActivateUser', data, { headers: this.headers });
    }
    AdminFilter(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/AdminFilter', datas, { headers: this.headers });
    }
    ODFilter(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/AdminODFilter', datas, { headers: this.headers });
    }
    searchfilter(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/SearchEmployee', datas, { headers: this.headers });
    }
    Forgetpwd(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/ForgotPassword', datas, { headers: this.headers });
    }
    Pagination(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/Pagination', datas, { headers: this.headers });
    }
    UpdateSettings(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/UpdateSettings', datas, { headers: this.headers });
    }
    localsearch(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/SearchadminEmployee', datas, { headers: this.headers });
    }
    admin_search(datas):Observable<any> {
        return this.http.post(this.base_url + '/api/AdminUser/SearchlocalAdmin', datas, { headers: this.headers });
    }
    allmap_details(datas):Observable<any> {
        debugger;
        console.log(datas); debugger;
        console.log(this.base_url);debugger;
        return this.http.post(this.base_url + '/api/AdminUser/GetRecentODDetails',datas,{ headers: this.headers });

    }
    select_time_dis():Observable<any> {
        debugger;
        return this.http.get(this.base_url + '/api/AdminUser/GetSettingsValue',{ headers: this.headers });
    }

    //   new edit on 06-12-2018
    autocheckout_distance(): Observable<any> {
        return this.http.get(this.base_url + '/api/AdminUser/GetAutoCheckoutDistance', { headers: this.headers });
    }

    autocheckout_time(): Observable<any> {
        return this.http.get(this.base_url + '/api/AdminUser/GetAutoCheckoutTime', { headers: this.headers });
    }
  }
